import {iosBookHttp} from './index'
import ElementUI, {Message} from "element-ui";

function iosBookRequest(url, method, data) {
    return iosBookHttp({
        url: url,
        method: method,
        data: data
    })
}

function requestBuffer(url, method, data) {
    return iosBookHttp({
        url: url,
        method: method,
        data: data,
        responseType: 'arraybuffer'
    })
}


export function downloadDataBook(url, data, fileName) {
    return requestBuffer(url, 'post', data).then(data => {
        try {
            let enc = new TextDecoder('utf-8')
            let body = JSON.parse(enc.decode(new Uint8Array(data.data)))
            if (body.status !== 0) {
                Message({
                    type: "error",
                    message: body.msg
                });
            }
        } catch (error) {
            console.log(error)
            let blobObject = new Blob([data.data]);
            //是IE浏览器
            if (!!window.ActiveXObject || "ActiveXObject" in window) {
                window.navigator.msSaveOrOpenBlob(blobObject, fileName);
            } else {//火狐谷歌都兼容
                //模板中要有一个预定义好的a标签
                let link = document.createElement("a");
                link.href = URL.createObjectURL(blobObject);
                link.download = fileName;
                link.click();
            }
            ElementUI.Message({
                message: '导出Excel成功！',
                type: "success",
            })
        }
    })
}

function get(url, data) {
    return iosBookRequest(url, 'get', data)
}

function post(url, data) {
    return iosBookRequest(url, 'post', data)
}

export function bookTaskSelections() {
    return get('/task/selections')
}

export function searchTask(data) {
    return post('/task/searchTask', data)
}

export function updateTaskState(taskId, state) {
    return get('/task/updateTaskState/' + taskId + "/" + state)
}

export function clean(ids, nickIds) {
    return get('/task/clearIds/' + ids + "/" + nickIds)
}

export function goodsSelections() {
    return get('/good/list')
}

export function goodsResource(url) {
    return get('/good/resource?url=' + url)
}

export function goodsResourceMax() {
    return get('/good/resource/max')
}

export function saveTask(data) {
    return post('/task/saveTask', data)
}

export function deleteGood(id) {
    return get('/good/delete?id=' + id)
}

export function searchGood(data) {
    return post('/good/search', data)
}

export function updateGood(data) {
    return post('/good/update', data)
}

export function bookGoodsCategoryList() {
    return get('/good/categoryList')
}

export function bookGoodsCategoryAll() {
    return get('/good/categoryAll')
}

export function bookGoodsLevel() {
    return get('/good/level')
}

//封面管理相关接口
export function saveCover(data) {
    return post('/cover/save', data)
}

export function deleteCover(id) {
    return get('/cover/delete/' + id)
}

export function searchCover(data) {
    return post('/cover/search', data)
}

//默认分类管理相关接口
export function saveCategory(data) {
    return post('/userCategory/save', data)
}

export function deleteCategory(id) {
    return get('/userCategory/delete/' + id)
}

export function searchCategory(data) {
    return post('/userCategory/search', data)
}

// 自定义管理分类部分相关接口
export function saveCategoryCustom(data) {
    return post('/userCategory/custom/save', data)
}

export function deleteCategoryCustom(id) {
    return get('/userCategory/custom/delete/' + id)
}

export function bookCustomType() {
    return get('/userCategory/custom/customTypes')
}

export function searchCategoryCustom(data) {
    return post('/userCategory/custom/search', data)
}

// 渠道管理相关接口
export function saveChannel(data) {
    return post('/channel/save', data)
}

export function deleteChannel(id) {
    return get('/channel/delete/' + id)
}

export function searchChannel(data) {
    return post('/channel/search', data)
}

export function allChannel() {
    return get('/channel/list')
}

// 渠道下载管理相关接口
export function saveChannelDownload(data) {
    return post('/channel/download/save', data)
}

export function deleteChannelDownload(id) {
    return get('/channel/download/delete/' + id)
}

export function searchChannelDownload(data) {
    return post('/channel/download/search', data)
}

// ios 版本更新相关接口v2
export function deleteVersionConfig(id) {
    return get('/version/delete?id=' + id)
}

export function searchVersionConfig(data) {
    return post('/version/search', data)
}

export function updateVersionConfig(data) {
    return post('/version/update', data)
}

// ios 版本更新文案相关接口v2
export function deleteVersionMessage(id) {
    return get('/version/message/delete?id=' + id)
}

export function searchVersionMessage(data) {
    return post('/version/message/search', data)
}

export function updateVersionMessage(data) {
    return post('/version/message/update', data)
}

//新版本配置
// export function ruleConfigList() {
//     return get('/config/list')
// }

export function deleteTotalRuleConfig(id) {
    return get('/config/total/delete/' + id)
}

export function deleteTotalVersion(version, appType) {
    return get('/config/total/deleteVersion?appType=' + appType + '&version=' + version)
}

export function saveTotalRuleConfig(data) {
    return post('/config/total/save', data)
}

export function searchTotalRuleConfig(data) {
    return post('/config/total/search', data)
}

export function totalVersionList(data) {
    return get('/config/total/listVersion?appType=' + data)
}

export function saveTotalVersion(data) {
    return post('/config/total/saveVersion', data)
}

export function findGoodById(id) {
    return get('/good/findGoodById/' + id)
}

export function shopSelections() {
    return get('/shop/selectionList')
}

// 获取商城子标签信息
export function subClassifySelections(parentId) {
    return get('/shop/subSelectionList?parentId=' + parentId)
}

export function searchShop(data) {
    return post('/shop/search', data)
}

export function deleteShopItem(itemId, deleted) {
    return get('/shop/delete/' + itemId + '/' + deleted)
}

export function saveShopItem(classifyId, data) {
    return post('/shop/save/' + classifyId, data)
}

export function classifyUpdate(data) {
    return post('/shop/classify/update', data)
}

export function shelvesListByClassifyId(id) {
    return get('/shop/itemList/' + id)
}

export function shopItemAll(id) {
    return get('/shop/itemListAll/' + id)
}

export function updateShelvesRank(data) {
    return post('/shop/itemList/updateRank', data)
}

export function shopItemClassifyListBook() {
    return get('/shop/shopItemClassifyList')
}

// 商城每日优惠相关接口
export function bookDailyShopItemType() {
    return get('/shop/daily/type')
}

export function searchDailyShopItem(data) {
    return post('/shop/daily/search', data)
}

export function saveDailyShopItem(data) {
    return post('/shop/daily/save', data)
}

export function deleteDailyShopItem(id) {
    return get('/shop/daily/delete?id=' + id)
}

export function orderSearch(data) {
    return post('/order/search', data)
}

export function orderSearch1(data) {
    return post('/order/search1', data)
}

export function sysVip(data) {
    return post('/order/sys/vip', data)
}

// 运营位相关
export function allOperationPosition() {
    return get('/operationPosition/list')
}

export function editOperationPosition(data) {
    return post('/operationPosition/saveAndUpdate', data)
}

export function allOperationPositionActivity(data) {
    return post('/operationPosition/activityList', data)
}

export function allSelect() {
    return get('/operationPosition/comboBoxList')
}

export function editOPActivity(data) {
    return post('/operationPosition/saveAndUpdateActivity', data)
}

export function deleteOPActivity(opaId) {
    return get('/operationPosition/deleteActivity/' + opaId)
}

export function adList(data) {
    return post('/ad/list',data)
}

export function adDetails(data) {
    return post('/ad/details',data)
}

export function saveAdId(data) {
    return post('/ad/save',data)
}

export function removeAdId(data) {
    return post('/ad/remove',data)
}